import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import 'react-html5-camera-photo/build/css/index.css'
import logoSpotter from '../../images/login-spotter-logo.png'
import ListHeader from '../common/ListHeader'
import { FieldTypes } from '../../utils/constants'
import Form from '../common/Form'

export default function UserEventsForm({
  onSubmit,
  userEvent,
  responseError,
  loading,
}) {
  const classes = useStyles()
  const [values, setValues] = useState({})

  useEffect(() => {
    setValues({ ...userEvent })
  }, [userEvent])

  const handleTakePhoto = (dataUri) => {
    setValues({ ...values, selfie: dataUri })
  }

  if (loading) {
    return (
      <div className={classes.paper}>
        <CircularProgress></CircularProgress>
      </div>
    )
  }
  if (responseError) {
    return (
      <div style={{ color: '#d51616', marginTop: '200px', fontSize: '26px' }}>
        {responseError.message || 'Ha ocurrido un error, contactenos'}
      </div>
    )
  }

  return (
    <div className={classes.paper}>
      <div className={classes.wrapper}>
        <img
          src={logoSpotter}
          style={{
            marginBottom: '20px',
            marginRight: '40px',
            marginTop: '20px',
          }}
          width="180px"
          alt="spotter"
        />
        <ListHeader
          bigTitle={`Registro a evento ${userEvent?.name}`}
          canCreate={false}
        />
        <Form
          values={values}
          setValues={setValues}
          extraWidth
          fields={[
            {
              type: FieldTypes.TextField,
              label: 'Nombre',
              hint: 'Ingrese un nombre',
              key: 'firstName',
              errorMessage: 'El nombre es requerido',
              capitalized: true,
            },
            {
              type: FieldTypes.TextField,
              label: 'Apellido',
              hint: 'Ingrese un apellido',
              key: 'lastName',
              errorMessage: 'El apellido es requerido',
              capitalized: true,
            },
            {
              type: FieldTypes.TextField,
              label: 'Teléfono',
              hint: 'Ingrese un teléfono',
              key: 'phone',
              errorMessage: 'El teléfono es requerido',
            },
            {
              type: FieldTypes.TextField,
              label: 'Cédula',
              hint: 'Ingrese una cédula',
              key: 'ci',
              errorMessage: 'La cédula es requerida',
            },
            {
              type: FieldTypes.TextField,
              label: 'Email',
              hint: 'Ingrese un email',
              key: 'email',
              errorMessage: 'El email es requerido',
            },
            {
              type: FieldTypes.TakePhoto,
              image: values.selfie,
              removePhoto: () => setValues({ ...values, selfie: null }),
              takePhoto: (dataUri) => {
                handleTakePhoto(dataUri)
              },
            },
          ]}
          handleSubmit={() => onSubmit(values)}
        />
      </div>
    </div>
  )
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& .Mui-error': {
      color: 'white',
    },
    '& .MuiFormHelperText-root': {
      color: '#f44336',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minHeight: '100vh',
    position: 'relative',
    '.react-html5-camera-photo>img': {
      width: '100%',
    },
  },
  wrapper: {
    maxWidth: '768px',
    width: '100%',
    padding: '20px',
  },
  inputStyle: {
    marginBottom: '26px',
    maxWidth: '768px',
    width: '100%',
    // backgroundColor: '#232935',
  },
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '20px',
    width: '100%',
  },
  button: {
    height: '50px',
    width: '100%',
    // maxWidth: '768px',
  },
  selfie: {
    width: '100%',
  },
  photoContainer: {
    '& > * > video': {
      // width: '100%',
    },
  },
  error: {
    color: '#f44336',
    marginBottom: '15px',
  },
}))
